import React from "react"
import moment from "moment"
import { getCategory } from "./agendaCategories"

// Bloc d'un Rdv dans la grille. Positionné en absolu dans la colonne du jour.
// Géométrie fournie par le parent : top / height (px) + lane / lanes (colonnes
// pour gérer les chevauchements).
const AgendaEvent = ({ rdv, top, height, lane, lanes, onClick }) => {
	const cat = getCategory(rdv.type)

	const debut = moment(rdv.debut)
	const fin = debut.clone().add(rdv.duree, "minutes")
	const plage = `${debut.format("HH:mm")} – ${fin.format("HH:mm")}`

	// Répartition horizontale en cas de chevauchement.
	const largeur = 100 / lanes
	const compact = height < 44

	// Le titre fait la une s'il existe (le « quoi ») ; sinon le client. La 2e ligne
	// montre alors le client (si titre en tête) ou le lieu.
	const titrePrincipal = rdv.titre || rdv.client || cat.label
	const complement = rdv.titre ? rdv.client : rdv.lieu

	return (
		<button
			type="button"
			onClick={(e) => {
				e.stopPropagation()
				onClick()
			}}
			title={`${plage} · ${[rdv.titre, rdv.client].filter(Boolean).join(" — ")}`}
			style={{
				position: "absolute",
				top,
				height: Math.max(height - 2, 18),
				left: `calc(${lane * largeur}% + 2px)`,
				width: `calc(${largeur}% - 4px)`,
				backgroundColor: cat.bg,
				borderLeft: `3px solid ${cat.color}`,
				borderRadius: 6,
				padding: compact ? "2px 6px" : "4px 8px",
				textAlign: "left",
				overflow: "hidden",
				cursor: "pointer",
				display: "flex",
				flexDirection: "column",
				gap: 1,
				boxSizing: "border-box",
				fontFamily: "inherit",
			}}
		>
			<span
				style={{
					fontSize: 12,
					fontWeight: 600,
					color: cat.color,
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis",
					lineHeight: 1.2,
				}}
			>
				{/* ✓ = Rdv concrétisé en mission de dispatch. */}
				{rdv.statut === "concretise" ? "✓ " : ""}
				{titrePrincipal}
			</span>
			{!compact && (
				<span
					style={{
						fontSize: 11,
						color: "#57534E",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						lineHeight: 1.2,
					}}
				>
					{plage}
					{complement ? ` · ${complement}` : ""}
				</span>
			)}
		</button>
	)
}

export default AgendaEvent
